import { render, staticRenderFns } from "./TrashReason.vue?vue&type=template&id=16cf2c9e&scoped=true"
import script from "./TrashReason.vue?vue&type=script&lang=js"
export * from "./TrashReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf2c9e",
  null
  
)

export default component.exports